export enum SignalingEvent {
  Register = 'register',
  Accept = 'accept',
  Reject = 'reject',
  Offer = 'offer',
  Answer = 'answer',
  Candidate = 'candidate',
  Close = 'close',
}
